import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["endColumn"]

  connect() {
    if (!this.hasEndColumnTarget) return

    // since table is vertically aligned, only calculate offset once for performance
    const offset = this.calculateOffset(this.endColumnTargets[0])

    this.endColumnTargets.forEach(cell => cell.style.right = `${offset}px`)
  }

  calculateOffset(cell) {
    const cells = Array.from(cell.parentElement.children)
    const nextCells = cells.slice(cells.indexOf(cell) + 1)

    const offset = nextCells
      .map(cell => cell.offsetWidth)
      .reduce((sum, width) => sum + width, 0)

    return offset
  }
}
